export enum SurveyTypeEnum {
  EMPLOYEE = "EMPLOYEE",
  CUSTOMER = "CUSTOMER",
}
